import * as React from "react"
import Svg, { G, Path } from "react-native-svg"
import { Icon } from 'native-base';

function SvgComponent(props) {
	return (
		<Icon
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 513.2 512.1"
			{...props}
		>
			<Path d="M1.1 0H513.2V512.1H1.1z" fill="none" />
			<Path
				d="M472.3 40.8L23.8 489.3"
				stroke="#000"
				strokeMiterlimit={10}
				strokeWidth="50px"
				fill="none"
			/>
			<Path d="M246.4 481.9c22 0 39.8-17.8 39.8-39.8v-39.5c0-18.92-13.17-34.72-30.85-38.78L137.27 481.9H246.4zM39.8 362.8c-22 0-39.8 17.8-39.8 39.8v4.43l44.23-44.23H39.8zM39.8 197.6c-22 0-39.8 17.8-39.8 39.8v39.5c0 22 17.8 39.8 39.8 39.8h50.53l119.1-119.1H39.8zM286.2 111.6V72.1c0-22-17.8-39.8-39.8-39.8H39.8C17.8 32.3 0 50.1 0 72.1v39.6c0 22 17.8 39.8 39.8 39.8h206.6c3.66 0 7.2-.51 10.57-1.43l27.77-27.77c.94-3.41 1.46-6.99 1.46-10.69zM448.22 170.95c1.88 2.78 2.98 6.14 2.98 9.75v191.2c0 9.6-7.8 17.5-17.5 17.5H340v61h93.7c43.3 0 78.5-35.2 78.5-78.5V180.7c-.05-20.42-7.91-39.03-20.72-53.01l-43.25 43.25zM416.28 202.89l-23.56 23.56c11.98-.32 23.3-9.6 23.56-23.56z" />
		</Icon>
	)
}

export default SvgComponent
